<script>
    export let opened = false;
</script>

<style>
    .popup-container {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: #0009;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 997;
    }

    .popup-content {
        background: #fff;
        border-radius: 2em;
        padding: 1em;
        max-width: 90vw;
        max-height: 90vh;
        box-sizing: content-box;
        overflow: auto;
    }
</style>

<svelte:window
    on:keydown={(event) => (opened && event.key === 'Escape' ? (opened = false) : null)} />
{#if opened}
    <div class="popup-container" on:mousedown={() => (opened = false)}>
        <div class="popup-content" on:mousedown|stopPropagation>
            <slot />
        </div>
    </div>
{/if}
